// extracted by mini-css-extract-plugin
module.exports = {"Tags":"TagsInput_Tags__2FWB7","TagsInput":"TagsInput_TagsInput__uyUjU","Info":"TagsInput_Info__2PlAI"};